<template>
  <div class="spaces-development">
    <h1>Spaces Header Development</h1>
    <p>Simulated skeleton below with current header version injection.</p>
    <p>Imports `http://localhost:8080/js/dp-spaces.js`.</p>

    <!-- Webpage Simulation Container -->
    <div style="display: flex; justify-content: center; align-items: center">
      <div
        style="
          width: 80%;
          border: 1px solid black;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-direction: column;
        "
      >
        <div id="dp-spaces-header-container">
          <div id="dp-spaces-header">
            <div class="dp-skeleton-buttons">
              <div class="dp-skeleton-button"></div>
              <div class="dp-skeleton-button"></div>
            </div>
          </div>
        </div>
        <div class="feegow-background">
          <img
            src="../assets/feegow-background.jpg"
            alt="Feegow Sim Background"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
#dp-spaces-header-container {
  position: relative;
  width: 100%;
  height: 40px;
  top: 0;
  z-index: 1040;
  background-color: #256ec3;
}
#dp-spaces-header-container,
#dp-spaces-header-container + header,
#dp-spaces-header-container + header + #sidebar_left,
#dp-spaces-header-container + header + #sidebar_right,
#dp-spaces-header-container + header + #sidebar_left + #content_wrapper {
  transition: all 0.3s ease-out;
}
#dp-spaces-header-container + header {
  top: 40px;
  height: 48px;
  border: none;
}
#dp-spaces-header-container + header + #sidebar_left,
#dp-spaces-header-container + header + #sidebar_left + #content_wrapper,
#dp-spaces-header-container
  + header
  + #sidebar_left
  + #content_wrapper
  + #sidebar_right {
  padding-top: 90px;
}
#dp-spaces-header-container.dp-collapsed {
  height: 16px;
}
#dp-spaces-header-container.dp-collapsed + header {
  top: 16px;
}
#dp-spaces-header-container.dp-collapsed + header + #sidebar_left,
#dp-spaces-header-container.dp-collapsed
  + header
  + #sidebar_left
  + #content_wrapper,
#dp-spaces-header-container.dp-collapsed
  + header
  + #sidebar_left
  + #content_wrapper
  + #sidebar_right {
  padding-top: 66px;
}

.dp-skeleton-buttons {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
  padding: 4px 5px;
  opacity: 0.75;
}
.dp-skeleton-button {
  border: none;
  border-radius: 0.5rem;
  display: inline-block;
  height: 32px;
  width: 85px;
  background: linear-gradient(90deg, #cbd9ff 25%, #e0eaff 50%, #cbd9ff 75%);
  background-size: 200% 100%;
  animation: dp-loading 1.5s infinite;
}
@keyframes dp-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>

<script lang="ts">
import { defineComponent, onMounted } from "vue";

// Simulate document.userProperties before loading the script
document.userProperties = {
  idInTable: 8,
  userId: 1,
  licencaID: 17973,
  tipoUsuario: "profissionais",
};

// Set localStorage tk for testing with pre-load

export default defineComponent({
  name: "DevelopmentSpacesView",
  setup() {
    onMounted(() => {
      const scriptsToLoad = [
        "http://localhost:8080/js/chunk-vendors.js",
        "http://localhost:8080/js/chunk-common.js",
        "http://localhost:8080/js/dp-spaces.js",
      ];

      const appendScript = (src: string) => {
        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
      };

      scriptsToLoad.forEach((src) => appendScript(src));
    });
  },
});
</script>
